import { render, staticRenderFns } from "./icon-close.vue?vue&type=template&id=a1b38798&scoped=true"
import script from "./icon-close.vue?vue&type=script&lang=js"
export * from "./icon-close.vue?vue&type=script&lang=js"
import style0 from "./icon-close.vue?vue&type=style&index=0&id=a1b38798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b38798",
  null
  
)

export default component.exports